export function CustomerActiveBadge({ status }) {
  switch (status) {
    case 0:
      return <span className="badge badge-warning">Isolir</span>;
    case 1:
      return <span className="badge badge-success">Aktif</span>;
    case 2:
      return <span className="badge badge-danger">Dismantled</span>;
    case 3:
      return <span className="badge badge-success">Aktif Trial</span>;
    case 4:
      return <span className="badge badge-danger">Dismantle Trial</span>;
    case 5:
      return <span className="badge badge-danger">Deaktivasi Isolir</span>;
    default:
      return <></>;
  }
}

export function InternetCustomerActiveBadge({ status }) {
  switch (status) {
    case 0:
      return <span className="badge badge-warning">Belum Diaktifkan</span>;
    case 1:
      return <span className="badge badge-success">Telah diaktifkan</span>;
    default:
      return <></>;
  }
}
